import { Clear, Home as HomeIcon } from "@mui/icons-material";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import AddShoppingCartRoundedIcon from "@mui/icons-material/AddShoppingCartRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PendingActionsRoundedIcon from "@mui/icons-material/PendingActionsRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import ContentPasteOffRoundedIcon from "@mui/icons-material/ContentPasteOffRounded";
import AdminHome from "@Pages/Admin/AdminHomePage/AdminHomePage";
import MaterialsListing from "@Pages/Admin/Materials/MaterialsListing";
import WarehousesListing from "@Pages/Admin/Warehouses/WarhousesListing";
import SuppliersListing from "@Pages/Admin/Suppliers/SuppliersListing";
import StorageLocationsListing from "@Pages/Admin/StorageLocations/StorageLocationsListing";
import ClearanceAgentsListing from "@Pages/Admin/ClearanceAgents/ClearanceAgentsListing";
import VendorsListing from "@Pages/Admin/Vendors/VendorsListing";
import CategoriesListing from "@Pages/Admin/Categories/CategoriesListing";
import BanksListing from "@Pages/Admin/Banks/BanksListing";
import ShippingLinesListing from "@Pages/Admin/ShippingLines/ShippingLinesListing";
import UsersListing from "@Pages/Admin/Users/UsersListing";
import PlannersListing from "@Pages/Admin/Planners/PlannersListing";
import RolesHomePage from "../../Pages/RolesHomePage/RolesHomePage";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PieChartIcon from "@mui/icons-material/PieChart";
import PendingOrdersListing from "@Pages/ClearanceCoordinator/Orders/ClearancePendingOrdersListing";
import Notification from "../../Pages/Notification/Notification";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ReleaseOrdersListing from "@Pages/OrderListing/ReleaseOrdersListing";
import CanceledOrdersListing from "@Pages/OrderListing/CanceledOrdersListing";
import ClearanceAgentPendingOrdersListing from "../../Pages/ClearanceAgent/ClearanceAgentPendingOrdersListing";
import ClearanceManagerPendingOrdersListing from "../../Pages/ClearanceManager/ClearanceManagerPendingOrders";
import FinancialCoordinatorPendingOrdersListing from "../../Pages/FinancialCoordinator/FinancialCoordinatorPendingOrdersListing";
import SyasatPendingOrderListing from "../../Pages/Syasat/SyasatPendingOrdersListing/SyasatPendingOrderListing";
import PlannerPendingOrderListing from "../../Pages/Planner/PlannerPendingOrdersListing/PlannerPendingOrderListing";
import Form4PendingOrdersListing from "../../Pages/Form4Coordinator/Form4PendingOrderslisting/Form4PendingOrdersListing";
import ClearanceDashboard from "../../Pages/Dashboards/ClearanceDashboard";
import PlanningManagerPendingOrdersListing from "../../Pages/PlanningManager/PlanningManagerPendingOrders/PlanningManagerPendingOrders";
import ClearanceCoordinatorHomePage from "../../Pages/ClearanceCoordinator/ClearanceCoordinatorHomePage/ClearanceCoordinatorHomePage";
import AllPendingOrdersListing from "../../Pages/OrderListing/AllPendingOrderListing";
import AllReleasedOrdersListing from "../../Pages/OrderListing/AllReleasedOrderListing";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import PaymentDashboard from "../../Pages/Dashboards/PaymentDashboard";
import PaymentsListing from "../../Pages/PaymentsListing/PaymentsListing";
import StarIcon from "@mui/icons-material/Star";
import ClearanceStarredOrdersListing from "../../Pages/ClearanceCoordinator/Orders/ClearanceStarredOrdersListing";
import ClearanceAgentStarredOrdersListing from "../../Pages/ClearanceAgent/ClearanceAgentStarredOrdersListing";
import ClearanceManagerStarredOrdersListing from "../../Pages/ClearanceManager/ClearanceManagerStarredOrdersListing";
import PlanningManagerStarredOrdersListing from "../../Pages/PlanningManager/PlannerManagerStarredOrderListing/PlannerManagerStarredOrderListing";
import FinancialCoordinatorStarredOrdersListing from "../../Pages/FinancialCoordinator/FinancialCoordinatorStarredOrdersListing";
import SyasatStarredOrderListing from "../../Pages/Syasat/SyasatStarredOrderListing/SyasatStarredOrderListing";
import PlannerStarredOrderListing from "../../Pages/Planner/PlannerStarredOrdersListing/PlannerStarredOrdersListing";
import Form4StarredOrdersListing from "../../Pages/Form4Coordinator/Form4StarredOrdersListing/Form4StarredOrdersListing";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import NotReadOnlyMSDSFilesListing from "../../Pages/MSDSFiles/NotReadOnlyMSDSFilesListing";
import ReadOnlyMSDSFilesListing from "../../Pages/MSDSFiles/ReadOnlyMSDSFilesListing";

import BulkInsert from "../../Pages/Admin/BulkInsert/BulkInsert";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import TransportationCoordinatorHomePage from "../../Pages/TransportationCoordinator/TransportationCoordinatorHomePage/TransportationCoordinatorHomePage";
import TransportationCoordinatorPendingOrder from "../../Pages/TransportationCoordinator/TransportationCoordinatorPendingOrder/TransportationCoordinatorPendingOrder";
import TransportationCoordinatorReleasedOrder from "../../Pages/TransportationCoordinator/TransportationCoordinatorReleasedOrder/TransportationCoordinatorReleasedOrder";
import TreasuryCoordinatorHomePage from "../../Pages/TreasuryCoordinator/TreasuryCoordinatorHomePage";
import TreasuryCoordinatorPendingOrder from "../../Pages/TreasuryCoordinator/TreasuryCoordinatorPendingOrders";
import TreasuryCoordinatorReleasedOrder from "../../Pages/TreasuryCoordinator/TreasuryCoordinatorReleaseOrder";
import TreasuryCoordinatorOrderListing from "../../Pages/TreasuryCoordinator/TreasuryCoordinatorOrderListing";
import ClearnaceCoordinatorTransactionListing from "../../Pages/ClearanceCoordinator/Orders/ClearanceCoorindatorTransactionListing";
import GroupedOrdersListing from "../../Pages/OrderListing/GroupedOrdersListing";
import ViewWeekRoundedIcon from "@mui/icons-material/ViewWeekRounded";
const AdminMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { AdminHome },
  },
  {
    text: "Users",
    icon: <PersonAddAltRoundedIcon />,
    path: DefaultRoutes.users,
    component: { UsersListing },
  },
  {
    text: "Clearance Agents",
    icon: <AssignmentIndRoundedIcon />,
    path: DefaultRoutes.clearanceAgents,
    component: { ClearanceAgentsListing },
  },
  {
    text: "Vendors",
    icon: <Inventory2RoundedIcon />,
    path: DefaultRoutes.vendors,
    component: { VendorsListing },
  },
  {
    text: "Categories",
    icon: <CategoryRoundedIcon />,
    path: DefaultRoutes.categories,
    component: { CategoriesListing },
  },
  {
    text: "Suppliers",
    icon: <Inventory2RoundedIcon />,
    path: DefaultRoutes.suppliers,
    component: { SuppliersListing },
  },
  {
    text: "Materials",
    icon: <AddShoppingCartRoundedIcon />,
    path: DefaultRoutes.materials,
    component: { MaterialsListing },
  },
  {
    text: "Shipping Lines",
    icon: <LocalShippingRoundedIcon />,
    path: DefaultRoutes.shippingLines,
    component: { ShippingLinesListing },
  },
  {
    text: "Warehouses",
    icon: <WarehouseRoundedIcon />,
    path: DefaultRoutes.warehouses,
    component: { WarehousesListing },
  },
  {
    text: "Storage Locations",
    icon: <PinDropRoundedIcon />,
    path: DefaultRoutes.storageLocations,
    component: { StorageLocationsListing },
  },
  {
    text: "Banks",
    icon: <AccountBalanceRoundedIcon />,
    path: DefaultRoutes.banks,
    component: { BanksListing },
  },
  {
    text: "Planners",
    icon: <AssignmentIndIcon />,
    path: DefaultRoutes.planners,
    component: { PlannersListing },
  },
  {
    text: "Bulk Insert",
    icon: <LibraryAddIcon />,
    path: DefaultRoutes.bulkInsert,
    component: { BulkInsert },
  },
];
const ExternalTreasuryCoordinatorMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { TreasuryCoordinatorHomePage },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { ClearnaceCoordinatorTransactionListing },
  },
  {
    text: "All Pending Orders",
    icon: <ListAltRoundedIcon />,
    path: DefaultRoutes.allPendingOrders,
    component: { TreasuryCoordinatorPendingOrder },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { TreasuryCoordinatorReleasedOrder },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { ClearanceStarredOrdersListing },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const TreasuryCoordinatorMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { TreasuryCoordinatorHomePage },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { TreasuryCoordinatorOrderListing },
  },
  {
    text: "All Pending Orders",
    icon: <ListAltRoundedIcon />,
    path: DefaultRoutes.allPendingOrders,
    component: { TreasuryCoordinatorPendingOrder },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { TreasuryCoordinatorReleasedOrder },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { ClearanceStarredOrdersListing },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const TransportationCoordinatorMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { TransportationCoordinatorHomePage },
  },
  {
    text: "All Pending Orders",
    icon: <ListAltRoundedIcon />,
    path: DefaultRoutes.allPendingOrders,
    component: { TransportationCoordinatorPendingOrder },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { TransportationCoordinatorReleasedOrder },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { ClearanceStarredOrdersListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const ClearanceCoordinatorMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { ClearanceCoordinatorHomePage },
  },
  {
    text: "My Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { PendingOrdersListing },
  },
  {
    text: "All Pending Orders",
    icon: <ListAltRoundedIcon />,
    path: DefaultRoutes.allPendingOrders,
    component: { AllPendingOrdersListing },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "My Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { AllReleasedOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { ClearnaceCoordinatorTransactionListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { ClearanceStarredOrdersListing },
  },
  {
    text: "Payments",
    icon: <AccountBalanceIcon />,
    path: DefaultRoutes.payments,
    component: { PaymentsListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { NotReadOnlyMSDSFilesListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const ClearanceAgentMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { ClearanceAgentPendingOrdersListing },
  },
  {
    text: "Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { ClearanceAgentStarredOrdersListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { NotReadOnlyMSDSFilesListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const ClearanceManagerMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { ClearanceManagerPendingOrdersListing },
  },
  {
    text: "Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { ClearnaceCoordinatorTransactionListing },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { ClearanceManagerStarredOrdersListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { ReadOnlyMSDSFilesListing },
  },
  {
    text: "Payments",
    icon: <AccountBalanceIcon />,
    path: DefaultRoutes.payments,
    component: { PaymentsListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Payment Dashboard",
    icon: <PieChartIcon />,
    path: DefaultRoutes.paymentDashboard,
    component: { PaymentDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const PlanningManagerMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { ClearnaceCoordinatorTransactionListing },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "All Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { PlanningManagerPendingOrdersListing },
  },
  {
    text: "All Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { PlanningManagerStarredOrdersListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { ReadOnlyMSDSFilesListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const FinancialMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { ClearnaceCoordinatorTransactionListing },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { FinancialCoordinatorPendingOrdersListing },
  },
  {
    text: "Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { FinancialCoordinatorStarredOrdersListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { ReadOnlyMSDSFilesListing },
  },
  {
    text: "Payments",
    icon: <AccountBalanceIcon />,
    path: DefaultRoutes.payments,
    component: { PaymentsListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const SyasatMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { SyasatPendingOrderListing },
  },
  {
    text: "Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { SyasatStarredOrderListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { NotReadOnlyMSDSFilesListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const PlannerMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "My Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { PlannerPendingOrderListing },
  },
  {
    text: "All Pending Orders",
    icon: <ListAltRoundedIcon />,
    path: DefaultRoutes.allPendingOrders,
    component: { AllPendingOrdersListing },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "My Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { AllReleasedOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { PlannerStarredOrderListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { ReadOnlyMSDSFilesListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];
const Form4MenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "Transaction Listing",
    icon: <ReceiptIcon />,
    path: DefaultRoutes.transactionOrderListing,
    component: { TreasuryCoordinatorOrderListing },
  },
  {
    text: "Group View",
    icon: <ViewWeekRoundedIcon />,
    path: DefaultRoutes.groupView,
    component: { GroupedOrdersListing },
  },
  {
    text: "Pending Orders",
    icon: <PendingActionsRoundedIcon />,
    path: DefaultRoutes.pendingOrders,
    component: { Form4PendingOrdersListing },
  },
  {
    text: "Released Orders",
    icon: <AssignmentTurnedInRoundedIcon />,
    path: DefaultRoutes.releasedOrders,
    component: { ReleaseOrdersListing },
  },
  {
    text: "Canceled Orders",
    icon: <ContentPasteOffRoundedIcon />,
    path: DefaultRoutes.canceledOrders,
    component: { CanceledOrdersListing },
  },
  {
    text: "Starred Orders",
    icon: <StarIcon />,
    path: DefaultRoutes.starredOrders,
    component: { Form4StarredOrdersListing },
  },
  {
    text: "MSDS Directory",
    icon: <FileCopyIcon />,
    path: DefaultRoutes.msdsdirectory,
    component: { ReadOnlyMSDSFilesListing },
  },
  {
    text: "Clearance Dashboard",
    icon: <DashboardIcon />,
    path: DefaultRoutes.clearanceDashboard,
    component: { ClearanceDashboard },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];

const QualityMemberMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { AllReleasedOrdersListing },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];

const WarehouseMemberMenuItems = [
  {
    text: "Home",
    icon: <HomeIcon />,
    path: DefaultRoutes.home,
    component: { RolesHomePage },
  },
  {
    text: "All Released Orders",
    icon: <FactCheckRoundedIcon />,
    path: DefaultRoutes.allReleasedOrders,
    component: { AllReleasedOrdersListing },
  },
  {
    text: "Notifications",
    icon: <NotificationsIcon />,
    path: DefaultRoutes.notifications,
    component: { Notification },
  },
];

const SideBarMenuItems = (Roles) => {
  switch (Roles[0]) {
    case "ADMIN":
      return AdminMenuItems;
    case "CLEARANCE_COORDINATOR":
      return ClearanceCoordinatorMenuItems;
    case "CLEARANCE_AGENT":
      return ClearanceAgentMenuItems;
    case "CLEARANCE_MANAGER":
      return ClearanceManagerMenuItems;
    case "FINANCIAL":
      return FinancialMenuItems;
    case "SYASAT":
      return SyasatMenuItems;
    case "PLANNER":
      return PlannerMenuItems;
    case "FORM_4":
      return Form4MenuItems;
    case "PLANNING_MANAGER":
      return PlanningManagerMenuItems;
    case "TRANSPORTATION_COORDINATOR":
      return TransportationCoordinatorMenuItems;
    case "QUALITY_MEMBER":
      return QualityMemberMenuItems;
    case "WAREHOUSE_MEMBER":
      return WarehouseMemberMenuItems;
    case "TREASURY_COORDINATOR":
      return TreasuryCoordinatorMenuItems;
    case "EXTERNAL_TREASURY_COORDINATOR":
      return ExternalTreasuryCoordinatorMenuItems;
    default:
      return [];
  }
};

export default SideBarMenuItems;
